export const isSentrySamplingDisabledForBrand = (): boolean =>
  process.env.REACT_APP_BRAND_NAME !== "trivagodeals" &&
  process.env.REACT_APP_BRAND_NAME !== "algotels" &&
  process.env.REACT_APP_BRAND_NAME !== "traveluro";

export const checkIsAgentSubdomain = (hostname: string | undefined): boolean => {
  const normalizedHostname = hostname?.toLowerCase().split(":")[0];

  return normalizedHostname ? /^agent(?:[.-]|$)/.test(normalizedHostname) : false;
};

type SentrySamplingContext = {
  hostname?: string;
};

export const getSentryTraceSampleRate = ({ hostname }: SentrySamplingContext = {}): number => {
  if (isSentrySamplingDisabledForBrand()) {
    return 0;
  }

  if (checkIsAgentSubdomain(hostname)) {
    return 0;
  }

  if (process.env.REACT_APP_BRAND_NAME === "algotels") {
    return 0.001;
  }

  return process.env.REACT_APP_ENVIRONMENT === "prod" ? 0.01 : 0.1;
};

export const getSentryLogSampleRate = ({ isAgentSubdomain = false }: { isAgentSubdomain?: boolean } = {}): number => {
  if (isSentrySamplingDisabledForBrand()) {
    return 0;
  }

  if (isAgentSubdomain) {
    return 0;
  }

  return process.env.REACT_APP_BRAND_NAME === "algotels" ? 0.1 : 1;
};
